import {
	Component,
	OnInit,
	ChangeDetectionStrategy,
	input,
	output,
	inject,
	resource,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { arrRemoveId, notId } from "@app/helpers"
import { ApiService, senderFactory } from "@app/services/api.service"
import { BtnExtComponent, TableWrapComponent } from "@app/utils/utils.component"

@Component({
	selector: "[row]",
	imports: [COMMON_IMPORTS, BtnExtComponent],
	template: `
		@for (
			field of ["user", "name", "current_text", "pending_text"];
			track field
		) {
			<td>{{ row()[field] }}</td>
		}
		<td>
			<app-btn-ext
				text="approve"
				(clickEv)="approve.run()"
				[isSpin]="approve.isLoading()"
			/>
			<app-btn-ext
				text="reject"
				[isSpin]="reject.isLoading()"
				(clickEv)="reject.run()"
			/>
		</td>
	`,
})
export class Row {
	apiService = inject(ApiService)
	row = input.required<any>()
	removed = output()

	reject = senderFactory({
		fn: () => this.apiService.post("invite_text_reject", { id: this.row().id }),
		onFinish: () => this.removed.emit(),
	})
	approve = senderFactory({
		fn: () =>
			this.apiService.post("invite_text_approve", { id: this.row().id }),
		onFinish: () => this.removed.emit(),
	})
}

@Component({
	selector: "app-invite-texts-approval",
	imports: [COMMON_IMPORTS, TableWrapComponent, Row],
	template: `
		<app-table-wrap fieldsStr="user,name,current_text,pending_text,actions">
			@if (rows.hasValue()) {
				@for (row of rows.value(); track row.id) {
					<tr
						[row]="row"
						(removed)="remove(row.id)"
					></tr>
				}
			}
		</app-table-wrap>
	`,
})
export class InviteTextApprovalComponent {
	apiService = inject(ApiService)
	rows = resource({
		loader: () =>
			this.apiService.get_gen_items_col("invite_texts", {
				isForApproval: true,
			}),
	})

	remove(id: number) {
		this.rows.update(arrRemoveId(id))
	}
}
